// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\n  background-color: purple;\n}\n\n#pageContentDiv{\n  padding: 0px;\n}\n\n.btn-purple {\n  color: #212529;\n  background-color: #f5d0ff;\n  border-color: #ddbaf6;\n}\n\n.m-tree>.m-node>.inner {\n  display: none;\n}\n\n/* .project .mainBody #content img {\n  width: 100%;\n} */\n\n.project .mainBody #content {\n  word-wrap: break-word;\n}\n", ""]);
// Exports
module.exports = exports;
